export const errorCodeTranslation: Record<string, string> = {
	UserNotFound: 'Invalid email or password',
	'error.enrichment.provider.not_found': 'Provider not found',
	'error.workspace.invitation.already': 'User already invited',
	'error.domain.malformated': 'Domain malformated',
	'error.linkedin.malformated': 'Linkedin malformated',
	'error.enrichment.field.already_enriched':
		'This field has been already enriched through all data providers'
};
